
import HORECA_1 from '../image/Catalog/HORECA/30л-30-HORECA.jpg'
import HORECA_2 from '../image/Catalog/HORECA/60-20-HORECA.jpg'
import HORECA_3 from '../image/Catalog/HORECA/90-10-HORECA.jpg'
import HORECA_4 from '../image/Catalog/HORECA/120-10-HORECA.jpg'
import HORECA_5 from '../image/Catalog/HORECA/120-25-HORECA.jpg'
import HORECA_6 from '../image/Catalog/HORECA/180-10-HORECA.jpg'
import HORECA_7 from '../image/Catalog/HORECA/180-25-HORECA.jpg'
import HORECA_8 from '../image/Catalog/HORECA/240-10-HORECA.jpg'

import HOUSEHOLD_1 from '../image/Catalog/HOUSEHOLD/60-20.jpg'
import HOUSEHOLD_2 from '../image/Catalog/HOUSEHOLD/90-10.jpg'
import HOUSEHOLD_3 from '../image/Catalog/HOUSEHOLD/120-10.jpg'
import HOUSEHOLD_4 from '../image/Catalog/HOUSEHOLD/120-25.jpg'
import HOUSEHOLD_5 from '../image/Catalog/HOUSEHOLD/150-10.jpg'
import HOUSEHOLD_6 from '../image/Catalog/HOUSEHOLD/180-10.jpg'
import HOUSEHOLD_7 from '../image/Catalog/HOUSEHOLD/180-25.jpg'
import HOUSEHOLD_8 from '../image/Catalog/HOUSEHOLD/210-10.jpg'
import HOUSEHOLD_9 from '../image/Catalog/HOUSEHOLD/240-10.jpg'
import HOUSEHOLD_10 from '../image/Catalog/HOUSEHOLD/240-25.jpg'
import HOUSEHOLD_11 from '../image/Catalog/HOUSEHOLD/300-10.jpg'
import HOUSEHOLD_12 from '../image/Catalog/HOUSEHOLD/360-10.jpg'

import UNIVERSAL_1 from '../image/Catalog/UNIVERSAL/120-25.jpg'
import UNIVERSAL_2 from '../image/Catalog/UNIVERSAL/120-50.jpg'
import UNIVERSAL_3 from '../image/Catalog/UNIVERSAL/160-25.jpg'
import UNIVERSAL_4 from '../image/Catalog/UNIVERSAL/180_b.jpg'
import UNIVERSAL_5 from '../image/Catalog/UNIVERSAL/280-10.jpg'
import UNIVERSAL_6 from '../image/Catalog/UNIVERSAL/120-10.jpg'
import UNIVERSAL_7 from '../image/Catalog/UNIVERSAL/240-10_1.jpg'
import UNIVERSAL_8 from '../image/Catalog/UNIVERSAL/360-10_1.jpg'

import CONSTRUCTION_1 from '../image/Catalog/CONSTRUCTION/120-10.jpg'
import CONSTRUCTION_2 from '../image/Catalog/CONSTRUCTION/180-10.jpg'
import CONSTRUCTION_3 from '../image/Catalog/CONSTRUCTION/240-10.jpg'

import TANKS_1 from '../image/Catalog/TANKS/120.jpg'
import TANKS_2 from '../image/Catalog/TANKS/240.jpg'
import TANKS_3 from '../image/Catalog/TANKS/120-1.jpg'

import TABLECLOTHS_1 from '../image/Catalog/TABLECLOTHS/1.jpg'
import TABLECLOTHS_2 from '../image/Catalog/TABLECLOTHS/2.jpg'
import TABLECLOTHS_3 from '../image/Catalog/TABLECLOTHS/3.jpg'

export const arrTABLECLOTHS = [ 
    { volume: 'Скатерть синяя', 
        alt: 'Скатерть желтая',  
        image: TABLECLOTHS_1},
    { volume: 'Скатерть желтая', 
        alt: 'Скатерть желтая',  
        image: TABLECLOTHS_2},    
    { volume: 'Скатерть зеленая', 
        number: '1',
        alt: 'Скатерть синяя',  
        image: TABLECLOTHS_3},                                                                                                   
    ]

export const arrTANKS = [ 
    { volume: '120', 
        number: '1',
        alt: 'пакеты для мусора 120 литров',  
        image: TANKS_1},
    { volume: '120', 
        number: '1',
        alt: 'пакеты для мусора 120 литров',  
        image: TANKS_3},    
    { volume: '240', 
        number: '1',
        alt: 'пакеты для мусора 240 литров',  
        image: TANKS_2},                                                                                                   
    ]

export const arrCONSTRUCTION = [ 
    { volume: '120', 
        number: '10',
        alt: 'пакеты для мусора 120 литров',  
        image: CONSTRUCTION_1},
    { volume: '180', 
        number: '10',
        alt: 'пакеты для мусора 180 литров',  
        image: CONSTRUCTION_2},
    { volume: '240', 
        number: '10',
        alt: 'пакеты для мусора 240 литров',  
        image: CONSTRUCTION_3},                                                                                                   
    ]

export const arrUNIVERSAL = [
    { volume: '120', 
        number: '10',
        alt: 'пакеты для мусора 120 литров',  
        image: UNIVERSAL_6}, 
    { volume: '120', 
        number: '25',
        alt: 'пакеты для мусора 120 литров',  
        image: UNIVERSAL_1},
    { volume: '120', 
        number: '50',
        alt: 'пакеты для мусора 120 литров',  
        image: UNIVERSAL_2},
    { volume: '160', 
        number: '25',
        alt: 'пакеты для мусора 160 литров',  
        image: UNIVERSAL_3},
    { volume: '240', 
        number: '10',
        alt: 'пакеты для мусора 240 литров',  
        image: UNIVERSAL_7},
    { volume: '360', 
        number: '10',
        alt: 'пакеты для мусора 360 литров',  
        image: UNIVERSAL_8},        
    { volume: '180', 
        number: '25',
        text: 'для бака 120 литров',
        alt: 'пакеты для мусора 180 литров',  
        image: UNIVERSAL_4},
    { volume: '280', 
        number: '10',
        text: 'для бака 240 литров',
        alt: 'пакеты для мусора 280 литров',  
        image: UNIVERSAL_5},                                                                                                          
    ]

export const arrHORECA = [ 
    { volume: '30', 
        number: '30',
        alt: 'пакеты для мусора 30 литров',  
        image: HORECA_1},
    { volume: '60', 
        number: '20',
        alt: 'пакеты для мусора 60 литров',  
        image: HORECA_2},
    { volume: '90', 
        number: '10',
        alt: 'пакеты для мусора 90 литров',  
        image: HORECA_3},
    { volume: '120', 
        number: '10',
        alt: 'пакеты для мусора 120 литров',  
        image: HORECA_4},
    { volume: '120', 
        number: '25',
        alt: 'пакеты для мусора 120 литров',  
        image: HORECA_5},
    { volume: '180', 
        number: '10',
        alt: 'пакеты для мусора 180 литров',  
        image: HORECA_6},
    { volume: '180', 
        number: '25',
        alt: 'пакеты для мусора 180 литров',  
        image: HORECA_7},
    { volume: '240', 
        number: '10',
        alt: 'пакеты для мусора 240 литров',  
        image: HORECA_8},                                                                                                   
    ]
    
    
    
    export const arrHOUSEHOLD = [ 
    { volume: '60', 
        number: '20',
        alt: 'пакеты для мусора 60 литров',  
        image: HOUSEHOLD_1},
    { volume: '90', 
        number: '10',
        alt: 'пакеты для мусора 90 литров',  
        image: HOUSEHOLD_2},
    { volume: '120', 
        number: '10',
        alt: 'пакеты для мусора 120 литров',  
        image: HOUSEHOLD_3},
    { volume: '120', 
        number: '25',
        alt: 'пакеты для мусора 120 литров',  
        image: HOUSEHOLD_4},
    { volume: '150', 
        number: '10',
        alt: 'пакеты для мусора 150 литров',  
        image: HOUSEHOLD_5},
    { volume: '180', 
        number: '10',
        alt: 'пакеты для мусора 180 литров',  
        image: HOUSEHOLD_6},
    { volume: '180', 
        number: '25',
        alt: 'пакеты для мусора 180 литров',  
        image: HOUSEHOLD_7},
    { volume: '210', 
        number: '10',
        alt: 'пакеты для мусора 210 литров',  
        image: HOUSEHOLD_8},
    { volume: '240', 
        number: '10',
        alt: 'пакеты для мусора 240 литров',  
        image: HOUSEHOLD_9},
    { volume: '240', 
        number: '25',
        alt: 'пакеты для мусора 240 литров',  
        image: HOUSEHOLD_10},
    { volume: '300', 
        number: '10',
        alt: 'пакеты для мусора 300 литров',  
        image: HOUSEHOLD_11},
    { volume: '360', 
        number: '10',
        alt: 'пакеты для мусора 360 литров',  
        image: HOUSEHOLD_12},                                                                                                                                       
    ]    




